import Hosts from '../../../Hosts';

const object_type = 'contest/form'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/contest_form'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: Hosts.companycode,

        type: 'tipo1',

        name_01: '',
        name_02: '',
        name_03: '',
        contact_01: '',
        contact_02: '',
        contact_03: '',
        designation: '',

        option_02: '',
        option_03: '',

        description_01: '',
        description_02: '',
        description_03: '',
        description_04: '',
        description_05: '',
        description_06: '',
        description_07: '',
        description_08: '',
        description_09: '',
        description_10: '',

        previsions: [
            {
                ano1: '',
                ano2: '',
                ano3: ''
            },
            {
                ano1: '',
                ano2: '',
                ano3: ''
            },
            {
                ano1: '',
                ano2: '',
                ano3: ''
            },
            {
                ano1: '',
                ano2: '',
                ano3: ''
            }
        ],

        files: [],

        status: 'under_review',
        notified: false,

        rgpd: false,
    }

}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
